// src/directives/draggable.js
export default {
  mounted(el) {
    const dialogHeader = el.querySelector('.el-dialog__header');
    const dialog = el.querySelector('.el-dialog');
    if (!dialogHeader || !dialog) return;

    dialogHeader.style.cursor = 'move';

    const onMouseDown = (e) => {
      if (!e.target.closest('.el-dialog__header')) return;
      e.preventDefault();

      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      const onMouseMove = (ev) => {
        let left = ev.clientX - offsetX;
        let top = ev.clientY - offsetY;

        // 边界限制
        const maxX = window.innerWidth - dialog.offsetWidth;
        const maxY = window.innerHeight - dialog.offsetHeight;
        left = Math.max(0, Math.min(left, maxX));
        top = Math.max(0, Math.min(top, maxY));

        dialog.style.left = left + 'px';
        dialog.style.top = top + 'px';
        dialog.style.margin = '0';
        dialog.style.transform = 'none';
        dialog.style.position = 'fixed';
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    dialogHeader.addEventListener('mousedown', onMouseDown);

    el._dragCleanup = () => {
      dialogHeader.removeEventListener('mousedown', onMouseDown);
      dialogHeader.style.cursor = '';
    };
  },
  unmounted(el) {
    if (el._dragCleanup) el._dragCleanup();
  }
};